import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'marketName',
    standalone: false
})
export class MarketNamePipe implements PipeTransform {
    transform(value: string): string {
        const [name] = value?.split(' ') || [''];

        return name;
    }
}
